import IconBase from './IconBase'

interface PropsType {
  width?: string | number
  height?: string | number
  className?: string
}

const PlusOIcon = (props: PropsType) => {
  const { width, height, className } = props
  return (
    <IconBase title="icon-plus-o" width={width} height={height} className={className}>
      <path d="M550 50v500H50V50h500m50-50H0v600h600V0z" />
      <path d="M450 275H325V150h-50v125H150v50h125v125h50V325h125v-50z" />
    </IconBase>
  )
}

export default PlusOIcon
